// ✅ Importaciones principales
import { useState } from 'react';
import { ButtonSiguiente, Input } from '../../ui';
import { Link, useNavigate } from 'react-router-dom';
import { isValidEmail } from '../../validation/validations';

// 🟢 URL base del backend, obtenida desde tu archivo .env
import { safeFetch } from '@/api/safeFetch';

const CodigoRecuperacion: React.FC = () => {

    // 🔥 Detectar si PreLaunch está activo
    const preLaunchActivo = import.meta.env.VITE_PRELAUNCH === "true";

    // 🔥 Ruta dinámica
    const loginRedirect = preLaunchActivo ? "/prelaunch" : "/sign";

    // Estados locales para manejar los valores del formulario
    const [email, setEmail] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // 🔹 Función principal que maneja el envío del formulario
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        setMensaje('');
        setError('');

        // 🧩 Validación del email antes de enviar
        if (!isValidEmail(email)) {
            setError('Por favor, ingresa un correo electrónico válido.');
            return;
        }

        setLoading(true);

        try {

            const response = await safeFetch("/api/codigoRecuperacion", {
                method: "POST",
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            // Guardar token
            if (data.token) {
                localStorage.setItem('token', data.token);
            }

            // ✅ Éxito
            if (data.mensaje && data.mensaje !== "Error") {

                localStorage.setItem('resetEmail', email);

                setMensaje(data.mensaje);

                setTimeout(() => {

                    setMensaje('');

                    navigate(`/verificarCodigo?email=${email}`);

                }, 3000);

            } else {

                setError('Hubo un error al enviar el código. Inténtalo de nuevo.');

                setTimeout(() => setError(''), 3000);
            }

        } catch (err) {

            console.error('Error en la solicitud:', err);

            setError('No se pudo procesar la solicitud. Inténtalo nuevamente.');

            setTimeout(() => setError(''), 3000);

        } finally {

            setLoading(false);
        }
    };

    return (

        <form
            className="flex flex-col justify-center items-center max-h-screen w-full pt-10 md:pt-20 px-6 z-50"
            onSubmit={handleSubmit}
        >

            <div className="w-full sm:w-11/12 md:w-8/12 lg:w-4/12 xl:w-4/12 2xl:w-3/12 p-10 space-y-4 border-2 rounded-lg border-r-4 border-t-4 border-red-700 shadow-md shadow-zinc-600">

                {/* Campo email */}
                <div className="relative border-b border-white focus-within:border-white">

                    <Input
                        type="email"
                        id="email"
                        placeholder="Correo electrónico"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full outline-none py-3 min-h-[48px] focus:placeholder-transparent focus:border-green-600"
                    />

                </div>

                {/* Mensajes */}
                {mensaje && !error && (
                    <p className="text-green-500 text-sm">
                        {mensaje}
                    </p>
                )}

                {error && (
                    <p className="text-red-500 text-sm">
                        {error}
                    </p>
                )}

                {/* Botón */}
                <div className="w-full">

                    <ButtonSiguiente
                        type="submit"
                        className="w-full bg-black text-white hover:text-black font-bold hover:bg-white shadow-md shadow-white active:shadow-blue-700"
                        disabled={loading}
                    >
                        {loading ? 'Enviando...' : 'Enviar'}
                    </ButtonSiguiente>

                </div>

                {/* Volver */}
                <div className="h-10 w-full text-center flex items-center justify-center transition-colors bg-zinc-600 shadow-md shadow-zinc-700 rounded-md duration-400 border active:shadow-blue-600 hover:border-blue-700 active:bg-white active:text-black text-white active:font-extrabold">

                    <Link
                        to={loginRedirect}
                        className="block"
                    >
                        Volver al inicio de sesión
                    </Link>

                </div>

            </div>

        </form>
    );
};

export default CodigoRecuperacion;